/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_select_race_constructors = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a race to see constructors`)
};

const es_f1_apex_select_race_constructors = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona una carrera para ver los constructores`)
};

const de_f1_apex_select_race_constructors = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle ein Rennen, um Konstrukteure zu sehen`)
};

const nl_f1_apex_select_race_constructors = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer een race om constructeurs te zien`)
};

const fr_f1_apex_select_race_constructors = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez une course pour voir les constructeurs`)
};

const it_f1_apex_select_race_constructors = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona una gara per vedere i costruttori`)
};

const pt_br2_f1_apex_select_race_constructors = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma corrida para ver os construtores`)
};

const pt_f1_apex_select_race_constructors = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma corrida para ver os construtores`)
};

const ja_f1_apex_select_race_constructors = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンストラクターを見るにはレースを選択`)
};

const zh_f1_apex_select_race_constructors = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择比赛查看车队`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_select_race_constructors = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_select_race_constructors(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_select_race_constructors", locale)
	if (locale === "en") return en_f1_apex_select_race_constructors(inputs)
	if (locale === "es") return es_f1_apex_select_race_constructors(inputs)
	if (locale === "de") return de_f1_apex_select_race_constructors(inputs)
	if (locale === "nl") return nl_f1_apex_select_race_constructors(inputs)
	if (locale === "fr") return fr_f1_apex_select_race_constructors(inputs)
	if (locale === "it") return it_f1_apex_select_race_constructors(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_select_race_constructors(inputs)
	if (locale === "pt") return pt_f1_apex_select_race_constructors(inputs)
	if (locale === "ja") return ja_f1_apex_select_race_constructors(inputs)
	return zh_f1_apex_select_race_constructors(inputs)
};